module.exports = __webpack_public_path__ + "static/media/r19.c623332d.jpg";